import React from "react";
import { Group, Paper } from "@mantine/core";
import { HiPlus } from "react-icons/hi2";
import CustomSearchBar from "../../ui/CustomSearchBar/CustomSearchBar";
import { CustomText } from "../../ui/CustomText/CustomText";
import CustomButton from "../../ui/CustomButton/CustomButton";

const MerchantFilters = ({
  onSearchChange,
  badgeCount,
  onAddMerchant,
  disableAddMerchant,
  addMerchantTitle,
}) => {
  return (
    <div className="flex-shrink-0">
      <Group justify="space-between" align="flex-end" className="mb-4">
        <div>
          <CustomText c="dimmed" size="sm" mt={4}>
            Create and manage merchants
          </CustomText>
        </div>
        <CustomButton
          onClick={onAddMerchant}
          leftSection={<HiPlus size={16} />}
          disabled={disableAddMerchant}
          title={addMerchantTitle}
        >
          Add Merchant
        </CustomButton>
      </Group>
      <Paper p="md" withBorder>
        <CustomSearchBar
          placeholder="Search merchants..."
          onSearchChange={onSearchChange}
          badgeCount={badgeCount}
          debounceDelay={500}
        />
      </Paper>
    </div>
  );
};

export default MerchantFilters;
